{
  "layout": {
    "tagline": "Tout ce qu'il vous faut pour livrer, au même endroit.",
    "subtitle": "Connectez-vous pour gérer votre espace de travail, votre équipe et vos données."
  },
  "login": {
    "title": "Connexion",
    "description": "Connectez-vous à votre compte pour continuer.",
    "email": "E-mail",
    "password": "Mot de passe",
    "rememberMe": "Se souvenir de moi",
    "submit": "Se connecter",
    "submitting": "Connexion en cours...",
    "forgotPassword": "Mot de passe oublié ?",
    "magicLink": "Se connecter avec un lien magique",
    "or": "ou",
    "magicLinkSent": "Lien magique envoyé ! Vérifiez votre e-mail.",
    "magicLinkError": "Échec de l'envoi du lien magique. Veuillez réessayer.",
    "noAccount": "Vous n'avez pas de compte ?",
    "register": "S'inscrire",
    "success": "Bon retour !",
    "error": "E-mail ou mot de passe incorrect. Veuillez réessayer.",
    "accountLocked": "Votre compte a été verrouillé en raison de trop nombreuses tentatives échouées. Vérifiez votre e-mail pour le déverrouiller.",
    "emailNotVerified": "Veuillez vérifier votre e-mail avant de vous connecter. Consultez votre boîte de réception pour trouver le lien de vérification."
  },
  "register": {
    "title": "Inscription",
    "description": "Créez un nouveau compte pour commencer.",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "E-mail",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "acceptTerms": "J'accepte les conditions générales",
    "submit": "Créer un compte",
    "submitting": "Création du compte...",
    "hasAccount": "Vous avez déjà un compte ?",
    "login": "Se connecter",
    "success": "Compte créé avec succès !",
    "successDescription": "Nous avons envoyé un e-mail de vérification à votre boîte de réception. Veuillez le consulter pour vérifier votre compte.",
    "error": "Échec de l'inscription. Veuillez réessayer.",
    "passwordStrength": {
      "label": "Force du mot de passe",
      "weak": "Faible",
      "fair": "Moyen",
      "strong": "Fort"
    }
  },
  "signup": {
    "title": "Créez votre compte",
    "description": "Configurez votre compte et votre organisation en quelques étapes.",
    "stepper": {
      "account": "1 Compte",
      "organization": "2 Organisation",
      "review": "3 Vérification",
      "compact": "Étape {{current}} sur {{total}}",
      "progress": "Progression de l'inscription"
    },
    "step1": {
      "email": "E-mail",
      "firstName": "Prénom",
      "lastName": "Nom",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le mot de passe"
    },
    "step2": {
      "orgName": "Nom de l'organisation",
      "subdomain": "Sous-domaine"
    },
    "step3": {
      "heading": "Vérifiez vos informations",
      "email": "E-mail",
      "name": "Nom",
      "orgName": "Organisation",
      "subdomain": "Adresse",
      "acceptTerms": "J'accepte les conditions générales"
    },
    "availability": {
      "checking": "Vérification de la disponibilité…"
    },
    "email": {
      "taken": "Cet e-mail est déjà enregistré. Essayez plutôt de vous connecter."
    },
    "subdomain": {
      "preview": "{{slug}}.myproduct.com",
      "available": "{{slug}}.myproduct.com est disponible",
      "taken": "Cette adresse est déjà prise. Essayez-en une autre."
    },
    "passwordStrength": {
      "label": "Force du mot de passe",
      "weak": "Faible",
      "fair": "Moyen",
      "strong": "Fort"
    },
    "continue": "Continuer",
    "back": "Retour",
    "submit": "Créer un compte",
    "submitting": "Création du compte...",
    "success": "Compte créé avec succès !",
    "error": "Une erreur est survenue lors de la création de votre compte. Veuillez réessayer.",
    "hasAccount": "Vous avez déjà un compte ?",
    "login": "Se connecter"
  },
  "invite": {
    "heading": "Vous rejoignez {{tenantName}}",
    "loading": "Vérification de votre invitation…",
    "email": "E-mail",
    "emailHelper": "Il s'agit de l'adresse à laquelle vous avez été invité.",
    "firstName": "Prénom",
    "lastName": "Nom",
    "password": "Mot de passe",
    "acceptTerms": "J'accepte les conditions générales",
    "submit": "Accepter l'invitation",
    "submitting": "Acceptation...",
    "success": "Invitation acceptée ! Vous pouvez maintenant vous connecter.",
    "error": "Une erreur est survenue lors de l'acceptation de votre invitation. Veuillez réessayer.",
    "invalidHeading": "Cette invitation n'est pas valide",
    "invalidBody": "Elle a peut-être expiré ou déjà été utilisée. Demandez à votre administrateur de vous en envoyer une nouvelle.",
    "goToSignIn": "Aller à la connexion",
    "passwordStrength": {
      "label": "Force du mot de passe",
      "weak": "Faible",
      "fair": "Moyen",
      "strong": "Fort"
    }
  },
  "welcome": {
    "heading": "Bienvenue chez {{orgName}} !",
    "headingGeneric": "Bienvenue !",
    "body": "Votre espace de travail est prêt. Invitez votre équipe ou commencez directement.",
    "goToDashboard": "Aller au tableau de bord",
    "inviteTeam": "Invitez votre équipe"
  },
  "twoFactor": {
    "title": "Authentification à deux facteurs",
    "description": "Saisissez le code à 6 chiffres de votre application d'authentification.",
    "codeLabel": "Code de vérification",
    "submit": "Vérifier",
    "submitting": "Vérification...",
    "useBackupCode": "Utiliser un code de secours",
    "useAuthenticator": "Utiliser l'application d'authentification",
    "useEmailCode": "Utiliser un code par e-mail",
    "emailCodeSent": "Un code de vérification a été envoyé à votre e-mail.",
    "emailCodeError": "Échec de l'envoi du code par e-mail. Veuillez réessayer.",
    "emailCodeLabel": "Code de vérification par e-mail",
    "emailCodeDescription": "Saisissez le code à 6 chiffres envoyé à votre e-mail.",
    "backupCodeLabel": "Code de secours",
    "backupCodeDescription": "Saisissez l'un de vos codes de secours.",
    "success": "Vérification réussie !",
    "error": "Code de vérification incorrect. Veuillez réessayer.",
    "backupError": "Code de secours incorrect. Veuillez réessayer.",
    "emailOtpError": "Code de vérification par e-mail incorrect. Veuillez réessayer.",
    "backToLogin": "Retour à la connexion"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "description": "Saisissez votre e-mail pour réinitialiser votre mot de passe.",
    "email": "E-mail",
    "submit": "Envoyer le lien de réinitialisation",
    "submitting": "Envoi...",
    "success": "Lien de réinitialisation envoyé !",
    "successDescription": "Si un compte existe avec cet e-mail, vous recevrez bientôt un lien de réinitialisation du mot de passe.",
    "backToLogin": "Retour à la connexion",
    "error": "Échec de l'envoi du lien de réinitialisation. Veuillez réessayer."
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "description": "Saisissez un nouveau mot de passe pour votre compte.",
    "password": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le nouveau mot de passe",
    "submit": "Réinitialiser le mot de passe",
    "submitting": "Réinitialisation...",
    "success": "Mot de passe réinitialisé avec succès !",
    "successDescription": "Vous avez été connecté automatiquement.",
    "backToLogin": "Retour à la connexion",
    "error": "Échec de la réinitialisation du mot de passe. Veuillez réessayer.",
    "invalidToken": "Ce lien de réinitialisation est invalide ou a expiré.",
    "twoFactorCode": "Code à double facteur",
    "twoFactorHint": "Saisissez le code à 6 chiffres de votre application d'authentification pour terminer la réinitialisation de votre mot de passe."
  },
  "checkEmail": {
    "title": "Vérifiez votre e-mail",
    "description": "Nous avons envoyé un e-mail de vérification à votre boîte de réception.",
    "instructions": "Cliquez sur le lien de vérification dans l'e-mail pour activer votre compte.",
    "backToLogin": "Retour à la connexion"
  },
  "verifyEmail": {
    "verifying": "Vérification de votre e-mail…",
    "successHeading": "E-mail vérifié",
    "successBody": "Votre adresse e-mail a été vérifiée.",
    "errorHeading": "Ce lien de vérification n'est pas valide",
    "errorBody": "Il a peut-être expiré ou déjà été utilisé. Connectez-vous pour en demander un nouveau.",
    "goToSignIn": "Aller à la connexion",
    "continueToWelcome": "Continuer"
  }
}
